module.exports = __webpack_public_path__ + "static/img/loading.424db906.png";